import { render, staticRenderFns } from "./LogoSlides.vue?vue&type=template&id=61124cb9&scoped=true"
import script from "./LogoSlides.vue?vue&type=script&lang=js"
export * from "./LogoSlides.vue?vue&type=script&lang=js"
import style0 from "./LogoSlides.vue?vue&type=style&index=0&id=61124cb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61124cb9",
  null
  
)

export default component.exports